<template>
  <div class="screen-table">
    <div class="screen-head">
      <span>{{ title }}</span>
    </div>

    <div class="screen-tb">
      <table>
        <tr class="head">
          <td colspan="6" class="title">气象数据</td>
        </tr>

        <tr class="head">
          <td>指标</td>
          <td>数值</td>
          <td>指标</td>
          <td>数值</td>
          <td>指标</td>
          <td>数值</td>
        </tr>

        <tr class="content" v-for="(row, ridx) in showCols" :key="`wr-${ridx}`">
          <td class="label">{{ row[0].name }}</td>
          <td class="value">{{ row[0].value }}</td>
          <td class="label">{{ row[1].name }}</td>
          <td class="value">{{ row[1].value }}</td>
          <td class="label">{{ row[2].name }}</td>
          <td class="value">{{ row[2].value }}</td>
        </tr>

        <!-- <tr class="content">
          <td class="label">空气温度</td>
          <td class="value"></td>
          <td class="label">风速</td>
          <td class="value"></td>
          <td class="label">土壤湿度</td>
          <td class="value"></td>
        </tr>

        <tr class="content">
          <td class="label">空气湿度</td>
          <td class="value"></td>
          <td class="label">气压</td>
          <td class="value"></td>
          <td class="label">日降雨量</td>
          <td class="value"></td>
        </tr> -->
      </table>
    </div>

    <div class="screen-tb">
      <table>
        <tr class="head">
          <td colspan="6" class="title">虫情数据【{{ Date.now() | formatDate('YYYY-MM-DD') }}】</td>
        </tr>

        <tr class="head">
          <td>虫类</td>
          <td>数量</td>
          <td>虫类</td>
          <td>数量</td>
        </tr>

        <tr class="content" v-for="(row, ridx) in shower" :key="`row-${ridx}`">
          <td class="label">{{ row[0].category }}</td>
          <td class="value">{{ row[0].today }}</td>
          <td class="label" v-if="row[1]">{{ row[1].category }}</td>
          <td class="value" v-if="row[1]">{{ row[1].today }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import * as api from '@/service/telemetry'
import { list as weatherApi, cols as colsApi } from '@/service/meteorology'
import sleep from '@/utlis/sleep'
import { formatWindDirection } from '@/utlis/formatter'

export default {
  data() {
    return {
      loading: true,
      warnings: [],
      weather: [],
      cols: []
    }
  },
  computed: {
    title() {
      return this.$route.query.title || '物联网病虫害实时监测系统'
    },
    shower() {
      let data = []
      let cols = 2
      this.warnings.slice(0, 6).forEach((w, idx) => {
        let row = Math.floor(idx / cols)
        if (!data[row]) {
          data.push([w])
        } else {
          data[row].push(w)
        }
      })
      return data
    },
    showCols() {
      let data = []
      let cols = 3
      this.cols.slice(0, 9).forEach((w, idx) => {
        let row = Math.floor(idx / cols)
        let item = {
          ...w,
          value:
            w.name === '风向'
              ? `${formatWindDirection(this.weather[w.key])}`
              : `${this.weather[w.key]} ${w.unit}`
        }
        if (!data[row]) {
          data.push([item])
        } else {
          data[row].push(item)
        }
      })
      return data
    }
  },
  async mounted() {
    let { companyId, device, weather, username, password } = this.$route.query
    this.login(username, password, companyId, device, weather)
  },
  methods: {
    async login(username, password, companyId, device, weather) {
      try {
        let user = this.$store.getters.user
        if (!(user && user.id)) {
          if (username && password) {
            await this.$store.dispatch('user/login', { username, password })
          }
        }

        if (companyId) {
          this.currentCompany = companyId
          await this.$store.dispatch('user/setCompanyId', companyId)
          await Promise.all([
            this.init(companyId, device, weather),
            this.$store.dispatch('user/warmup')
          ])
        }
      } catch (e) {
        console.log(e)
        this.$message.error('用户信息错误')
      } finally {
        this.loging = false
      }
    },
    async init(companyId, key, deviceId) {
      try {
        this.loading = true
        const [
          { data },
          { data: weather },
          { data: cols }
        ] = await Promise.all([
          api.getWarnings(companyId),
          weatherApi({ companyId, deviceId, type: 'last' }),
          colsApi(deviceId),
          sleep(1)
        ])
        this.warnings = data.warnings
          .filter(w => w.key === key)
          .sort((a, b) => b.today - a.today)
        this.weather = weather
        this.cols = cols
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.screen-table {
  width: 100%;
  height: 100%;
  background-color: #303133;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #fff;
  padding: 4px;
  box-sizing: border-box;

  .screen-head {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
    // padding: 2px 0;
    letter-spacing: 2px;
    display: flex;
    justify-content: center;
    align-items: baseline;
  }
  .screen-tb {
    flex: 1;
    &:not(:last-child) {
      margin-bottom: 2px;
    }
    table {
      border-collapse: collapse; /* 确保边框合并，这样就不会有多余的间隙 */
      width: 100%;
      height: 100%;
      border-spacing: 0;
    }
    td,
    th {
      border: 1px solid #67c23a; /* 为每个单元格添加边框 */
      text-align: center;
      height: 6px;
      line-height: 8px;
      box-sizing: border-box;
      vertical-align: middle;
      padding: 0;
    }
    .title {
      font-size: 15px;
    }
    .head {
      color: #ff6c6c;
      text-shadow: 0 0 1px #000;
    }
    .label {
      color: #e6a23c;
    }
  }
}
</style>
